const { createAction } = require("../../helpers");
const {
  GET_FAVOURITES,
  GET_FAVOURITES_SUCCESS,
  GET_FAVOURITES_RESET,
  GET_FAVOURITES_ERROR,
  UPDATE_FAVOURITES,
  UPDATE_FAVOURITES_SUCCESS,
  UPDATE_FAVOURITES_RESET,
  UPDATE_FAVOURITES_ERROR,
} = require("./constants");

/**
 * @param {Array<string>} iatas
 * @return {Promise<*>}
 */

const getFavourites = ( userId ) => createAction(GET_FAVOURITES, { userId });

const getFavouritesSuccess = (data) =>
  createAction(GET_FAVOURITES_SUCCESS, { data });
         
const getFavouritesError = (error) =>
  createAction(GET_FAVOURITES_ERROR, { error });

const getFavouriteReset = () => createAction(GET_FAVOURITES_RESET);

const updateFavourites = ({ userId, productsId }) =>
  createAction(UPDATE_FAVOURITES, {
    userId,
    productsId,
  });

const updateFavouritesSuccess = (data) =>
  createAction(UPDATE_FAVOURITES_SUCCESS, { data });

const updateFavouritesError = (error) =>
  createAction(UPDATE_FAVOURITES_ERROR, { error });

const updateFavouritesReset = () => createAction(UPDATE_FAVOURITES_RESET);

module.exports = {
  getFavourites,
  getFavouritesSuccess,
  getFavouritesError,
  getFavouriteReset,

  updateFavourites,
  updateFavouritesSuccess,
  updateFavouritesError,
  updateFavouritesReset,
};
